module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c10-9f239a94ded1a1ed45cbe922290ee324.jpg";